import { getAppBarConfig } from '@/components/layout/navbar/navbar.config';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import useCustomer from '@/hooks/user/useCustomer';
import { IconButton } from '@montugroup/design-system';
import CloseIcon from '@mui/icons-material/Close';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logout from '../sidebar/Logout';
import { StyledMenuIcon, StyledMenuIconContainer, StyledNavigationBar, StyledNavToolbar } from './MobileAppBar.styles';
import NavMenuItem from './NavMenuItem';

function MobileAppBar() {
  const { Logo } = usePortalPartnerBrand();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

  const handleLinkClick = () => {
    scrollToTop();
    toggleMenu();
  };
  const { flags } = useFeatureFlags();
  const { data: customer } = useCustomer();
  const mainMenuItems = getAppBarConfig({ flags, customer });

  return (
    <StyledNavigationBar>
      <StyledNavToolbar>
        <Link to="/home" onClick={scrollToTop}>
          <Logo />
        </Link>

        <StyledMenuIconContainer>
          <IconButton size="small" aria-haspopup="true" aria-label="menu" onClick={toggleMenu}>
            <StyledMenuIcon />
          </IconButton>
        </StyledMenuIconContainer>
      </StyledNavToolbar>
      <SwipeableDrawer
        anchor="right"
        open={menuOpen}
        onClose={toggleMenu}
        onOpen={toggleMenu}
        slotProps={{
          paper: {
            sx: {
              width: '100%',
              backgroundColor: (theme) => theme.palette.primary.main,
            },
          },
        }}
      >
        <StyledNavToolbar
          sx={{
            marginTop: (theme) => theme.spacing(1),
          }}
        >
          <Link to="/home" onClick={toggleMenu}>
            <Logo />
          </Link>

          <StyledMenuIconContainer>
            <IconButton onClick={toggleMenu}>
              <CloseIcon
                sx={{
                  color: (theme) => theme.palette.common.white,
                }}
              />
            </IconButton>
          </StyledMenuIconContainer>
        </StyledNavToolbar>

        {mainMenuItems.map((mainMenuItem) => (
          <NavMenuItem key={mainMenuItem.id} menuItem={mainMenuItem} onClick={handleLinkClick} />
        ))}

        <Logout />
      </SwipeableDrawer>
    </StyledNavigationBar>
  );
}

export default MobileAppBar;
